import { all, takeLatest } from 'redux-saga/effects';
import { clientCCLITypes, clientCCLISaga } from '@bit/gerenciatd.telcovid.redux-saga-client-c-c-l-i';
import { registerTypes as productsCCLITypes, registerSaga as productsCCLISaga } from '@bit/gerenciatd.telcovid.redux-saga-products-c-c-l-i';
import { types } from '../reducers/home';
import { types as commonTypes } from '../reducers/common';
import {
  getHomeInfo, getUpdateInfoSession,
} from './home';
import { getBusinessProps } from './common';

if (window.location.href.includes('127.0.0.1')) {
  sessionStorage.setItem('consultaCallesCP', 'mock');
  sessionStorage.setItem('consultaCalles', 'mock');
  sessionStorage.setItem('consultaDatosBancarios', 'mock');
  sessionStorage.setItem('consultaDatosClienteG', 'mock');
  sessionStorage.setItem('consultaDatosClienteM', 'mock');
  sessionStorage.setItem('consultaOfertaExtendida', 'mock');
  sessionStorage.setItem('consultaDatosLineaM', 'mock');
  sessionStorage.setItem('consultaDatosLineaF', 'mock');
  sessionStorage.setItem('consultaCarro', 'mock');
  sessionStorage.setItem('validarCntrM', 'mock');
  sessionStorage.setItem('generaPresentacionGestion', 'mock');
  sessionStorage.setItem('consultaParque', 'mock');
  sessionStorage.setItem('consultaGestion', 'mock');
  sessionStorage.setItem('traduccionBi', 'mock');
}
if (window.location.hostname.includes('col10mgmt')) sessionStorage.setItem('isQA', 'true');
else sessionStorage.setItem('isQA', 'false');

export default function* rootSaga() {
  yield all([
    takeLatest(types.GET_HOME_INFO_BEGINS, getHomeInfo),
    takeLatest(commonTypes.GET_BUSINESS_CONSTANTS, getBusinessProps),
    takeLatest(
      clientCCLITypes.GET_DATOS_CLIENTE_G_BEGINS,
      clientCCLISaga.getDatosClientes
    ),
    takeLatest(
      productsCCLITypes.GET_CONSULTA_DATOS_LINEAS_M_BEGINS,
      productsCCLISaga.getConstultaDatosLineasM
    ),
    takeLatest(
      productsCCLITypes.GET_CONSULTA_DATOS_LINEA_F_BEGINS,
      productsCCLISaga.getConsultaDatosLineaF
    ),
  ]);
}
